import { Kpis } from "../../shared/types";
import { createEvent } from "@cobuildlab/react-simple-state";

export const OnFetchKpis = createEvent<Kpis>();
export const OnFetchKpisError = createEvent();
